import { checkHeadlessBrowser } from '../../utils/headless-check'

const HeadlessCheck = (props) => {
  if (checkHeadlessBrowser()) {
    return (
      <div>
        <h1>We detected that this webpage is being accessed by a robot.</h1>
        <p>We kindly ask you to switch to a standard web browser for the best experience.</p>
      </div>
    )
  }

  return props.children
}

export default HeadlessCheck
